<template>
  <div class="claimList">
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <div class="main">
      <template v-if="list.length > 0 ">
        <div
          class="claim-item"
          @click="goDetail(item)"
          v-for="item in list"
          :key="item.order_id"
        >
          <p class="claim-no">索赔登记号：{{item.claimNumber}}</p>
          <p class="claim-status" v-if="item.claimState == 0">索赔受理中</p>
          <p class="claim-status" v-if="item.claimState == 1">索赔失败</p>
          <p class="claim-status" v-if="item.claimState == 2">索赔成功</p>
          <div class="claim-icon" v-if="item.claimState == 0"></div>
          <div class="claim-icon-failed" v-if="item.claimState == 1"></div>
          <div class="claim-icon-success" v-if="item.claimState == 2"></div>
        </div>
      </template>

      <div class="empty" v-if="list.length == 0">
        <div class="icon"></div>
        <p class="empty-text">您还没有进行任何索赔</p>
      </div>
    </div>
  </div>
</template>

<script>
const AES = require("@/lib/Utils/AES").default;
import { commitClamList } from "../services/common/index";
import { Toast } from 'vant'
export default {
  name: "newclaimList",
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  mounted() {
    commitClamList()
      .then((res) => {
        const { data , retCd, msg} = res
        this.list = data;
        console.log(`commitClamList`, commitClamList);
      })
      .catch((err) => {
        const { retCd, msg } = err;
        this.$toast('请求失败，请稍后重试');
      });
  },
  methods: {
    goDetail(val) {
      this.$router.push({
        path: "/new/claimDetail",
        query: {
          ...val,
        },
      });
    },
  },
};
</script>

<style scoped>
.claimList {
  padding-top: 15px;
}
.main {
  margin-top: 0;
  position: relative;
}
.main .empty {
  position: fixed;
  margin-top: -53px;
  width: 100%;
  height: 106px;
  top: 50%;
}
.main .empty .icon {
  width: 50px;
  height: 60px;
  margin: 0 auto;
  background-image: url(../images/empty.png);
  background-repeat: no-repeat;
  -webkit-background-size: 100%;
  background-size: 100%;
}
.main .empty-text {
  text-align: center;
  width: 100%;
  padding: 0;
}
.claim-item {
  position: relative;
  display: block;
  border-top: 6px solid #6ab8f8;
  background-color: #ffffff;
  text-decoration: none;
}
.claim-item p {
  line-height: 46px;
}
.claim-item .claim-no,
.claim-item .claim-status {
  font-size: 13px;
  width: 65%;
  padding-right: 0;
}
.claim-item .claim-no {
  border-bottom: 1px solid #f2f2f2;
  color: #666666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.claim-item .claim-status {
  color: #f55e52;
}
.claim-item .claim-icon,
.claim-item .claim-icon-success,
.claim-item .claim-icon-failed {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 16px;
  right: 22px;
  background-repeat: no-repeat;
  -webkit-background-size: 100%;
  background-size: 100%;
}
.claim-item img {
  width: 20%;
  position: absolute;
  right: 3%;
  top: 15px;
}
.claim-item .claim-icon {
  background-image: url(../images/claim.png);
}
.claim-item .claim-icon-success {
  background-image: url(../images/claim_success.png);
}
.claim-item .claim-icon-failed {
  background-image: url(../images/claim_failed.png);
}
.claim-item.success .claim-status {
  color: #0285f0;
}
.claim-item.failed .claim-status {
  color: #b6b6b6;
}
</style>



// WEBPACK FOOTER //
// claimList.vue?2a89bf15